<template>
  <div class="payments">
    <div class="payments__spinner" v-if="paymentsSpinner">
      <v-progress-circular indeterminate></v-progress-circular>
      {{ $t('Transaction.PleaseWait') }}
    </div>
    <div v-else>
      <h2 v-if="(!mobileBigAndBelow && brandTemplate === 'generic_2') || brandTemplate !== 'generic_2'" class="payments__title">{{ $t('Transaction.Cashier') }}</h2>
      <div class="payments__instruments">
        <div v-if="depositType">
          <component
            v-for="(item, index) in depositItems"
            :key="index"
            :is="item.is"
            :class="['payments__instruments_item', item.type || '', { diss: !customerCanDeposit }]"
            :type="item.type"
            @click.native="xtremepushEvent(...item.event)"
            :ref="item.type || item.is"
          />
        </div>
        <div v-if="withdrawType">
          <component
            v-for="(item, index) in withdrawalItems"
            :key="index"
            :is="item.is"
            @click.native="xtremepushEvent(...item.event)"
          />
        </div>
      </div>
    </div>
    <PNMEventDispatcher/>
    <NuveiEventDispatcher/>
  </div>
</template>
<script>
import CircularRotate from '@/components/common/CircularRotate'
import Screen from '@/components/mixins/Screen'
import Forms from '@/components/mixins/Forms'
import ProcessingDialog from '@/components/common/ProcessingDialog'
import Url from '@/components/mixins/Url'
import Branding from '@/components/mixins/Branding'
import store from '@/store'
import PNMDebit from '@/components/payments/PayNearMeGateway/PNMDebit'
import PNMCredit from '@/components/payments/PayNearMeGateway/PNMCredit'
import PNMCash from '@/components/payments/PayNearMeGateway/PNMCash'
import PNMAch from '@/components/payments/PayNearMeGateway/PNMAch'
import PNMGPay from '@/components/payments/PayNearMeGateway/PNMGPay'
import PNMAPay from '@/components/payments/PayNearMeGateway/PNMAPay'
import PNMPayPal from '@/components/payments/PayNearMeGateway/PNMPayPal'
import PNMVenmo from '@/components/payments/PayNearMeGateway/PNMVenmo'
import userAgent from '@/library/core/userAgent'
import PNMEventDispatcher from '@/components/payments/PayNearMeGateway/PNMEventDispatcher'
import PaysafeItem from '@/components/payments/PaysafeItem'
import SightlineSBItem from '@/components/payments/sb/SightlineSBItem'
import SightlineItem from '@/components/payments/SightlineItem'
import PayNearMeItem from '@/components/payments/PayNearMeItem'
import PNMPushDebitItem from '@/components/payments/PayNearMeGateway/PNMPushDebitItem'
import CashInShopItem from '@/components/payments/CashInShopItem'
import PNMPayPalWithdrawalItem from '@/components/payments/PayNearMeGateway/PNMPayPalWithdrawalItem'
import PNMVenmoWithdrawalItem from './PayNearMeGateway/PNMVenmoWithdrawalItem'
import NuveiCard from '@/components/payments/Nuvei/NuveiCard'
import NuveiEventDispatcher from '@/components/payments/Nuvei/NuveiEventDispatcher'
import NuveiPayPal from '@/components/payments/Nuvei/NuveiPayPal'
import NuveiVP from '@/components/payments/Nuvei/NuveiVP'
import NuveiACH from '@/components/payments/Nuvei/NuveiACH'
import NuveiAPay from '@/components/payments/Nuvei/NuveiAPay'
import NuveiPNM from '@/components/payments/Nuvei/NuveiPNM'
import NuveiPlayPlus from '@/components/payments/Nuvei/NuveiPlayPlus'
import NuveiVenmo from '@/components/payments/Nuvei/NuveiVenmo'
import NuveiWd from '@/components/payments/Nuvei/NuveiWd'
import analyticsBridge from '@/library/analyticsBridge'
import NuveiWdCardLink from '@/components/payments/Nuvei/NuveiWdCardLink'
import NuveiWdPayPalLink from '@/components/payments/Nuvei/NuveiWdPayPalLink'
import NuveiWdACHLink from '@/components/payments/Nuvei/NuveiWdACHLink'
import NuveiWdPlayPlusLink from '@/components/payments/Nuvei/NuveiWdPlayPlusLink'
import NuveiWdVippLink from '@/components/payments/Nuvei/NuveiWdVippLink'
import nuveiManager from '@/library/payments/nuveiManager'
import pnmManager from '@/library/payments/pnmManager'
import config from '@/config'

let viewModel
export default {
  components: {
    CircularRotate,
    ProcessingDialog,
    PNMDebit,
    PNMCredit,
    PNMCash,
    PNMAch,
    PNMGPay,
    PNMAPay,
    PNMEventDispatcher,
    PNMPayPal,
    PNMVenmo,
    PaysafeItem,
    SightlineSBItem,
    SightlineItem,
    PayNearMeItem,
    PNMPushDebitItem,
    CashInShopItem,
    PNMPayPalWithdrawalItem,
    PNMVenmoWithdrawalItem,
    NuveiCard,
    NuveiEventDispatcher,
    NuveiPayPal,
    NuveiVP,
    NuveiACH,
    NuveiAPay,
    NuveiPNM,
    NuveiPlayPlus,
    NuveiVenmo,
    NuveiWd,
    NuveiWdCardLink,
    NuveiWdPayPalLink,
    NuveiWdACHLink,
    NuveiWdPlayPlusLink,
    NuveiWdVippLink
  },
  mixins: [Screen, Forms, Url, Branding],
  computed: {
    fetchingPaymentTypes: () => store.getters['payments/fetchingPaymentTypes'],
    isPNMDebitAvailable: () => store.getters['pnmGateway/pnmDebit/isPNMDebitAvailable'],
    isPNMCreditAvailable: () => store.getters['pnmGateway/pnmCredit/isPNMCreditAvailable'],
    isPNMCashAvailable: () => store.getters['pnmGateway/pnmCash/isPNMCashAvailable'],
    isPNMAchAvailable: () => store.getters['pnmGateway/pnmAch/isPNMAchAvailable'],
    isPNMAPayAvailable: () => store.getters['pnmGateway/pnmAPay/isPNMAPayAvailable'],
    isPNMGPayAvailable: () => store.getters['pnmGateway/pnmGPay/isPNMGPayAvailable'],
    isPNMPayPalAvailable: () => store.getters['pnmGateway/pnmPayPal/isPNMPayPalAvailable'],
    isPNMVenmoAvailable: () => store.getters['pnmGateway/pnmVenmo/isPNMVenmoAvailable'],
    currentRef: () => store.getters['pnmGateway/currentRef'],
    currentNuveiRef: () => store.getters['nuvei/currentRef'],
    isiOS: () => userAgent.os.name === 'ios',
    transactionType: () => store.getters['payments/transactionType'],
    depositType () {
      return this.transactionType && this.transactionType === 'deposit'
    },
    withdrawType () {
      return this.transactionType && this.transactionType === 'withdrawal'
    },
    userIsVerifed: () => store.getters['getIsCustomerVerified'],
    accountSummaryFlow: () => window.ctsautoconf.ACCOUNT_SUMMARY_FLOW,
    customerContext: () => store.getters['getCustomerContext'],
    customerCanDeposit () {
      return this.customerContext && this.customerContext.ActionDeposit
    },
    customerCanWithdraw () {
      return this.customerContext && this.customerContext.ActionWithdraw
    },
    customerCanDepositAndWithdraw () {
      return this.customerCanDeposit && this.customerCanWithdraw
    },
    isMobileWeb () {
      return store.getters['screenState/getMobileBigAndBelow']
    },
    isMobileApp: () => window.ctsautoconf.MOBILE_LS,
    isMobile () {
      return this.isMobileWeb || this.isMobileApp
    },
    isNuveiCardAvailable: () => store.getters['nuvei/nuveiCard/isPaymentInstrumentAvailable'],
    isNuveiPayPalAvailable: () => store.getters['nuvei/nuveiPayPal/isPaymentInstrumentAvailable'],
    isNuveiVPAvailable: () => store.getters['nuvei/nuveiVP/isPaymentInstrumentAvailable'],
    isNuveiACHAvailable: () => store.getters['nuvei/nuveiACH/isPaymentInstrumentAvailable'],
    isNuveiAPayAvailable: () => store.getters['nuvei/nuveiAPay/isPaymentInstrumentAvailable'],
    isNuveiPNMAvailable: () => store.getters['nuvei/nuveiPNM/isPaymentInstrumentAvailable'],
    isNuveiPlayPlusAvailable: () => store.getters['nuvei/nuveiPlayPlus/isPaymentInstrumentAvailable'],
    isNuveiVenmoAvailable: () => store.getters['nuvei/nuveiVenmo/isPaymentInstrumentAvailable'],
    isNuveiWdAvailable: () => store.getters['nuvei/nuveiWd/isPaymentInstrumentAvailable'],
    isNuveiCardCheckProcessing: () => store.getters['nuvei/nuveiWd/cardCheckProcessing'],
    paymentsSpinner () {
      return this.fetchingPaymentTypes || (this.isNuveiCardCheckProcessing && this.withdrawType)
    },
    xtremePushEnabledMobile () { return window.ctsautoconf.XTREMEPUSH_ANALYTICS && window.ctsautoconf.XTREMEPUSH_ANALYTICS.MOBILE_APP }, // for mobile apps only
    depositItems () {
      const map = {
        PaysafeItem: this.customerCanDeposit ? { is: 'PaysafeItem', event: ['deposit', 'paySafe'] } : null,
        SightlineSBItem: { is: 'SightlineSBItem', event: ['deposit', 'sightline'] },
        SightlineItem: { is: 'SightlineItem', event: ['deposit', 'sightline'] },
        PayNearMeItem: { is: 'PayNearMeItem', event: ['deposit', 'payNearMe'] },
        PNMDebit: this.isPNMDebitAvailable ? { is: 'PNMDebit', event: ['deposit', 'payNearMe'], type: 'pnmDebit' } : null,
        PNMCredit: this.isPNMCreditAvailable ? { is: 'PNMCredit', event: ['deposit', 'payNearMe'], type: 'pnmCredit' } : null,
        PNMCash: this.isPNMCashAvailable ? { is: 'PNMCash', event: ['deposit', 'payNearMe'], type: 'pnmCash' } : null,
        PNMAch: this.isPNMAchAvailable ? { is: 'PNMAch', event: ['deposit', 'pnmAch'], type: 'pnmAch' } : null,
        PNMVenmo: this.isPNMVenmoAvailable ? { is: 'PNMVenmo', event: ['deposit', 'payNearMe'], type: 'pnmVenmo' } : null,
        PNMAPay: this.isPNMAPayAvailable && this.isiOS ? { is: 'PNMAPay', event: ['deposit', 'payNearMe'], type: 'pnmAPay' } : null,
        PNMGPay: this.isPNMGPayAvailable ? { is: 'PNMGPay', event: ['deposit', 'payNearMe'], type: 'pnmGPay' } : null,
        PNMPayPal: this.isPNMPayPalAvailable ? { is: 'PNMPayPal', event: ['deposit', 'payNearMe'], type: 'pnmPayPal' } : null,
        NuveiCard: this.isNuveiCardAvailable ? { is: 'NuveiCard', event: ['deposit', 'nuvei'], type: 'nuveiCard' } : null,
        NuveiPayPal: this.isNuveiPayPalAvailable ? { is: 'NuveiPayPal', event: ['deposit', 'nuvei'], type: 'nuveiPayPal' } : null,
        NuveiVP: this.isNuveiVPAvailable ? { is: 'NuveiVP', event: ['deposit', 'nuvei'], type: 'nuveiVP' } : null,
        NuveiACH: this.isNuveiACHAvailable ? { is: 'NuveiACH', event: ['deposit', 'nuvei'], type: 'nuveiACH' } : null,
        NuveiAPay: this.isNuveiAPayAvailable && this.isiOS ? { is: 'NuveiAPay', event: ['deposit', 'nuvei'], type: 'nuveiAPay' } : null,
        NuveiPNM: this.isNuveiPNMAvailable ? { is: 'NuveiPNM', event: ['deposit', 'nuvei'], type: 'nuveiPNM' } : null,
        NuveiPlayPlus: this.isNuveiPlayPlusAvailable ? { is: 'NuveiPlayPlus', event: ['deposit', 'nuvei'], type: 'nuveiPlayPlus' } : null,
        NuveiVenmo: this.isNuveiVenmoAvailable ? { is: 'NuveiVenmo', event: ['deposit', 'nuvei'], type: 'nuveiVenmo' } : null
      }
      return this.depositOrder
        .map(key => map[key])
        .filter(Boolean) // remove unavailable ones
    },
    withdrawalItems () {
      const map = {
        PaysafeItem: { is: 'PaysafeItem', event: ['withdrawal', 'paySafe'] },
        SightlineSBItem: { is: 'SightlineSBItem', event: ['withdrawal', 'sightline'] },
        SightlineItem: { is: 'SightlineItem', event: ['withdrawal', 'sightline'] },
        PNMPushDebitItem: { is: 'PNMPushDebitItem', event: ['withdrawal', 'payNearMe'] },
        CashInShopItem: { is: 'CashInShopItem', event: ['withdrawal', 'cashInShop'] },
        PNMPayPalWithdrawalItem: { is: 'PNMPayPalWithdrawalItem', event: ['withdrawal', 'payNearMe'] },
        PNMVenmoWithdrawalItem: { is: 'PNMVenmoWithdrawalItem', event: ['withdrawal', 'payNearMe'] },
        NuveiWdCardLink: { is: 'NuveiWdCardLink', event: ['withdrawal-card', 'nuvei'] },
        NuveiWdPayPalLink: { is: 'NuveiWdPayPalLink', event: ['withdrawal', 'nuvei'] },
        NuveiWdACHLink: { is: 'NuveiWdACHLink', event: ['withdrawal', 'nuvei'] },
        NuveiWdPlayPlusLink: { is: 'NuveiWdPlayPlusLink', event: ['withdrawal', 'nuvei'] },
        NuveiWdVippLink: { is: 'NuveiWdVippLink', event: ['withdrawal', 'nuvei'] }
      }
      return this.withdrawalOrder
        .map(key => map[key])
        .filter(Boolean)
    },
    depositOrder () {
      const orderFromConfig = config.app.autoconf.PAYMENTS.deposit_order
      const thereAreItems = orderFromConfig && orderFromConfig.length > 0
      if (thereAreItems) {
        return orderFromConfig
      }
      return [
        'PaysafeItem',
        'SightlineSBItem',
        'SightlineItem',
        'PayNearMeItem',
        'PNMDebit',
        'PNMCredit',
        'PNMCash',
        'PNMAch',
        'PNMAPay',
        'PNMGPay',
        'PNMPayPal',
        'PNMVenmo',
        'NuveiCard',
        'NuveiPayPal',
        'NuveiVP',
        'NuveiACH',
        'NuveiAPay',
        'NuveiPNM',
        'NuveiPlayPlus',
        'NuveiVenmo'
      ]
    },
    withdrawalOrder () {
      const orderFromConfig = config.app.autoconf.PAYMENTS.withdrawal_order
      const thereAreItems = orderFromConfig && orderFromConfig.length > 0
      if (thereAreItems) {
        return orderFromConfig
      }
      return [
        'PaysafeItem',
        'SightlineSBItem',
        'SightlineItem',
        'PNMPushDebitItem',
        'CashInShopItem',
        'PNMPayPalWithdrawalItem',
        'PNMVenmoWithdrawalItem',
        'NuveiWdCardLink',
        'NuveiWdPayPalLink',
        'NuveiWdACHLink',
        'NuveiWdPlayPlusLink',
        'NuveiWdVippLink'
      ]
    }
  },
  methods: {
    closePNMIFrame () {
      if (this.$refs && this.$refs[this.currentRef] && this.$refs[this.currentRef][0] && this.$refs[this.currentRef][0].closePNMIFrame) {
        this.$refs[this.currentRef][0].closePNMIFrame()
      }
      if (this.$refs && this.$refs[this.currentRef] && this.$refs[this.currentRef].closePNMIFrame) {
        this.$refs[this.currentRef].closePNMIFrame()
      }
      if (this.currentRef === 'pnmPushDebit') {
        store.commit(`pnmGateway/pnmPushDebit/redirectionURL`, undefined)
        store.commit(`pnmGateway/currentRef`, null)
      }
    },
    closeNuveiIFrame () {
      if (this.$refs && this.$refs[this.currentNuveiRef] && this.$refs[this.currentNuveiRef][0] && this.$refs[this.currentNuveiRef][0].closeNuveiIFrame) {
        this.$refs[this.currentNuveiRef][0].closeNuveiIFrame()
      }
      if (this.$refs && this.$refs[this.currentNuveiRef] && this.$refs[this.currentNuveiRef].closeNuveiIFrame) {
        this.$refs[this.currentNuveiRef].closeNuveiIFrame()
      }
    },
    xtremepushEvent (type, provider) {
      if (window.xtremepush || this.xtremePushEnabledMobile) {
        let event = {
          'param1': 'event',
          'param2': 'page_view',
          'param3': {
            'pageName': document.title || 'wallet-page',
            'sport': 'N/A',
            'sportsbookTab': 'N/A',
            'pagePath': document.location.pathname,
            'destinationUrl': window.location.href,
            'paymentAction': type,
            'paymentProvider': provider
          }
        }
        analyticsBridge.xtremePush(event, false)
      }
    }
  },
  created () {
    viewModel = this
  },
  mounted () {
    nuveiManager.handleNuveiOnMount()
  }
}
window.addEventListener('message', params => {
  pnmManager.handleIFrame(params, viewModel)
  nuveiManager.handleIFrame(params, viewModel)
})
</script>

<style lang="stylus" scoped>
@import "~@/css/config"
@import "~@/css/mixins"
@import "~@/css/sportIcons"

.payments
  background white
  @media mobile-big-and-below
    padding 15px 5px 15px
  .payments__spinner
    text-align center
  .payments__title
    margin-bottom 15px
    @media mobile-big-and-below
      margin-bottom 10px
  .payments__info
    .here
      font-family:  'Open Sans Bold'
      cursor pointer
      text-decoration underline
    @media mobile-big-and-below
      .desc
        display block
  .payments__instruments
    margin 0 150px
    @media mobile-big-and-below
      margin 0
    .payments__instruments_item
      cursor pointer
      display flex
      min-height 60px
      border-top 1px solid #cfd6db
      border-left 1px solid #cfd6db
      border-right 1px solid #cfd6db
      padding 5px 0
      border-radius 7px
      &:last-child
        border-bottom 1px solid #cfd6db
      &.diss
        cursor default
        background-color #E3E8EE
      .piitem-picture,
      >>> .piitem-picture
        display flex
        flex 3
        justify-content center
        align-items center
        padding 0 5px
        img
          width 100%
          height auto
      .piitem-text,
      >>> .piitem-text
        flex 20
        display flex
        justify-content center
        flex-direction column
        .piitem-text-headline
          font-size 15px
          font-weight normal
          font-family 'Open Sans Bold'
          .piitem-must-deposit
            border-radius 4px
            background-color white
            font-weight normal
            font-family 'Open Sans Bold'
            font-size 1rem
            line-height 1rem
            padding 4px 6px
            display inline-block
        .piitem-text-desc
          font-size 12px
      .piitem-arrow,
      >>> .piitem-arrow
        display flex
        flex 1
        justify-content center
        align-items center
        i
          font-size 40px
</style>



// WEBPACK FOOTER //
// src/components/payments/Payments.vue